// import React from "react";
// import {
//   Paper,
//   Typography,
//   Grid,
//   FormControlLabel,
//   Switch,
//   Divider,
// } from "@mui/material";
// import { useForm } from "react-hook-form";
// import WSTextField from "../../Components/TextBox/WSTextBox";

// type ThemeFormValues = {
//   darkMode: boolean;
//   compactMode: boolean;
//   primaryColor: string;
//   fontSize: string;
// };

// const ThemeSettings: React.FC = () => {
//   const { control, setValue, watch } = useForm<ThemeFormValues>({
//     defaultValues: {
//       darkMode: false,
//       compactMode: false,
//       primaryColor: "#1976d2",
//       fontSize: "medium",
//     },
//   });

//   const values = watch();

//   const handleToggle = (key: "darkMode" | "compactMode") => {
//     setValue(key, !values[key]);
//   };

//   return (
//     <Paper sx={{ p: 3, borderRadius: 3 }}>
//       <Typography variant="h6" fontWeight="bold" mb={2}>
//         Theme Settings
//       </Typography>

//       <Divider sx={{ mb: 2 }} />

//       <Grid container spacing={2}>
//         {/* Toggles */}
//         <Grid item xs={12} sm={6}>
//           <FormControlLabel
//             control={
//               <Switch
//                 checked={values.darkMode}
//                 onChange={() => handleToggle("darkMode")}
//               />
//             }
//             label="Dark Mode"
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <FormControlLabel
//             control={
//               <Switch
//                 checked={values.compactMode}
//                 onChange={() => handleToggle("compactMode")}
//               />
//             }
//             label="Compact Mode"
//           />
//         </Grid>

//         {/* Inputs */}
//         <Grid item xs={12} sm={6}>
//           <WSTextField
//             id="primaryColor"
//             name="primaryColor"
//             label="Primary Color"
//             control={control}
//             setValue={setValue}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <WSTextField
//             id="fontSize"
//             name="fontSize"
//             label="Font Size"
//             control={control}
//             setValue={setValue}
//           />
//         </Grid>
//       </Grid>
//     </Paper>
//   );
// };

// export default ThemeSettings;



import React from "react";
import { Paper, Typography, Grid, Divider } from "@mui/material";
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSColorPicker from "../../Components/ColorPicker/WSColorPicker";
import { useWatch } from "react-hook-form";

const ThemeSettings = ({ control, setValue }: any) => {
  const values = useWatch({ control });

  return (
    <Paper sx={{ p: 3, borderRadius: 3 }}>
      <Typography variant="h6" mb={2}>
        Theme Settings
      </Typography>

      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        {/* Theme Type */}
        {/* <Grid item xs={12} sm={6}>
          <WSTextField
            id="themeType"
            name="themeType"
            label="Theme Type (light/dark)"
            control={control}
            setValue={setValue}
          />
        </Grid> */}

        {/* Primary */}
        <Grid item xs={12} sm={6}>
          <WSColorPicker
            name="palette.primary.main"
            label="Primary Color"
            control={control}
            setValue={setValue}
            value={values?.palette?.primary?.main}
          />
        </Grid>

        {/* Secondary */}
        <Grid item xs={12} sm={6}>
          <WSColorPicker
            name="palette.secondary.main"
            label="Secondary Color"
            control={control}
            setValue={setValue}
            value={values?.palette?.secondary?.main}
          />
        </Grid>

        {/* Background */}
        <Grid item xs={12} sm={6}>
          <WSColorPicker
            name="palette.background.default"
            label="Background Color"
            control={control}
            setValue={setValue}
            value={values?.palette?.background?.default}
          />
        </Grid>

        {/* Text */}
        <Grid item xs={12} sm={6}>
          <WSColorPicker
            name="palette.text.primary"
            label="Text Color"
            control={control}
            setValue={setValue}
            value={values?.palette?.text?.primary}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ThemeSettings;